import { fork } from 'redux-saga/effects';

import * as providerLocations from './requests/provider-locations-req';
import * as providerServices from './requests/provider-services-req';
import * as practiceProviders from './requests/practice-providers-req';
import * as intersections from './requests/intersection-counts-req';
import * as workslotInsert from './requests/workslot-insert-req';
import * as workslotRemove from './requests/workslot-remove-req';
import * as workslotUpdate from './requests/workslot-update-req';
import * as blockslotInsert from './requests/blockslot-insert-req';
import * as blockslotRemove from './requests/blockslot-remove-req';
import * as blockslotUpdate from './requests/blockslot-update-req';
import * as scheduleList from './requests/schedule-search-req';
import * as patientTypes from './requests/patient-type-req';
import * as createAppointment from './requests/create-apppointment-req';
import * as inspectAppointment from './requests/appointment-inspector-req';
import * as patientList from './requests/patients-by-provider-req';
import * as visitTypes from './requests/visit-type-by-location-req';
import * as scheduleDefaults from './requests/schedule-defaults-req';
import scheduleErrorHandlingSaga from './sagas/error-handling-saga';
import onRemoveScheduleSaga from './sagas/on-remove-schedule-saga';
import handleBlockslotInsert from './sagas/blockslot-insert-saga';
import workslotInsertSaga from './sagas/workslot-insert-saga';
import fetchScheduleSaga from './sagas/fetch-schedule-saga';
import validateOnMount from './sagas/validate-on-mount-saga';
import editWorkRecursionSaga from './sagas/edit-work-recursion-saga';
import editBlockRecursionSaga from './sagas/edit-block-recursion-saga';
import popverHoverSaga from './sagas/popover-hover-saga';
import createAppointmentSaga from './sagas/create-appointment-saga';
import appointmentGuardSaga from './sagas/appointment-guard-saga';

export default function* scheduleRootSaga() {
  yield fork(providerLocations.watcher);
  yield fork(providerServices.watcher);
  yield fork(practiceProviders.watcher);
  yield fork(intersections.watcher);
  yield fork(blockslotInsert.watcher);
  yield fork(blockslotRemove.watcher);
  yield fork(blockslotUpdate.watcher);
  yield fork(workslotInsert.watcher);
  yield fork(workslotRemove.watcher);
  yield fork(workslotUpdate.watcher);
  yield fork(scheduleList.watcher);
  yield fork(patientTypes.watcher);
  yield fork(createAppointment.watcher);
  yield fork(inspectAppointment.watcher);
  yield fork(patientList.watcher);
  yield fork(visitTypes.watcher);
  yield fork(scheduleDefaults.watcher);
  yield fork(appointmentGuardSaga);
  yield fork(scheduleErrorHandlingSaga);
  yield fork(handleBlockslotInsert);
  yield fork(workslotInsertSaga);
  yield fork(editBlockRecursionSaga);
  yield fork(editWorkRecursionSaga);
  yield fork(onRemoveScheduleSaga);
  yield fork(fetchScheduleSaga);
  yield fork(validateOnMount);
  yield fork(popverHoverSaga);
  yield fork(createAppointmentSaga);
}



// WEBPACK FOOTER //
// ./src/redux/schedule/root-saga.js